import React from "react";
import { Bell } from "lucide-react";

interface TopBarProps {
  breadcrumbs?: string[];
  notificationCount?: number;
  onNotificationsClick?: () => void;
}

export function TopBar({
  breadcrumbs = [],
  notificationCount = 0,
  onNotificationsClick,
}: TopBarProps) {
  return (
    <div
      className="bg-duvi-surface border-b border-duvi-border flex items-center justify-between px-6"
      style={{ height: "var(--topbar-height)" }}
    >
      {/* Left: Breadcrumbs */}
      <div
        className="flex items-center gap-2 text-duvi-text-secondary"
        style={{ fontSize: "var(--text-sm)" }}
      >
        {breadcrumbs.map((crumb, idx) => (
          <React.Fragment key={idx}>
            {idx > 0 && <span>/</span>}
            <span
              className={
                idx === breadcrumbs.length - 1 ? "text-duvi-text-primary" : ""
              }
            >
              {crumb}
            </span>
          </React.Fragment>
        ))}
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-4 ml-auto">
        {/* Notification Bell */}
        <button
          className="relative text-duvi-text-secondary hover:text-duvi-text-primary transition-colors"
          onClick={onNotificationsClick}
        >
          <Bell className="w-5 h-5" />
          {notificationCount > 0 && (
            <span
              className="absolute -top-1 -right-1 w-4 h-4 bg-duvi-destructive rounded-full flex items-center justify-center text-white"
              style={{
                fontSize: "10px",
                fontWeight: "var(--font-weight-semibold)",
              }}
            >
              {notificationCount > 9 ? "9+" : notificationCount}
            </span>
          )}
        </button>
      </div>
    </div>
  );
}
